import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ProductCountdown } from './ProductCountdown';
export const ProductCountdownRenderer = () => {
    const [portalElement, setPortalElement] = useState(null);
    useEffect(() => {
        // Find the target element
        const element = document.getElementById('sb-product-countdown');
        if (element) {
            setPortalElement(element);
        }
        else {
            console.warn('ProductCountdownRenderer: Target element "sb-product-countdown" not found');
        }
    }, []);
    // Only render if we found the target element
    if (!portalElement) {
        return null;
    }
    // Use createPortal to render the countdown component into the target element
    return createPortal(_jsx(ProductCountdown, {}), portalElement);
};
